import { decamelizeKeys } from "humps";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { ProfileItem } from "PFApp/components/profile_item";
import { useProfilePreview } from "PFApp/use_profile_preview";
import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { useIsUnbiasedMode } from "PFCore/hooks/use_is_unbiased_mode";
import { ActivityHistoryProfile } from "PFCore/services/activity";
import { BasicProfile, Profile } from "PFTypes";

type HistoryEntryProfileProps = {
  profile: Profile | ActivityHistoryProfile;
  subtitle?: string;
  event?: string;
};

export const HistoryEntryProfile = ({ profile, subtitle, event }: HistoryEntryProfileProps) => {
  const activity = useCurrentActivity();
  const isUnbiasedMode = useIsUnbiasedMode(activity?.reviewers);

  const isShortlistEvent = event?.startsWith("shortlist_");

  const { showPreview } = useProfilePreview();

  const isSuspended = !!profile.suspendedAt;
  const handleProfileClick = () => {
    const decamelizedProfile = decamelizeKeys(profile) as Profile;
    showPreview({ id: profile.id, profile: decamelizedProfile });
  };

  return (
    <Inline gap="spacingXl" spread>
      <ProfileItem
        profile={profile as BasicProfile}
        displayJobTitle={false}
        displaySuspendedDate={true}
        displaySuspendedDateBelow={false}
        rootFlexProps={{ gap: null }}
        onClick={!isSuspended ? handleProfileClick : undefined}
        isUnbiasedMode={isShortlistEvent && isUnbiasedMode}
      />
      {!!subtitle && (
        <Typography variant="bodyRegular" clipOverflow>
          {subtitle}
        </Typography>
      )}
    </Inline>
  );
};
